module.exports = __webpack_public_path__ + "img/20240531_6.b4e8241a.jpg";